import { Skeleton, SkeletonText, Stack, VStack } from '@chakra-ui/react';
import React from 'react';

export const LoadingState: React.FC = () => {
  return (
    <VStack gap={6} align="stretch">
      <Skeleton height="80px" rounded="lg" />
      <Stack gap={4}>
        <SkeletonText noOfLines={2} />
        <Skeleton height="200px" rounded="lg" />
        <Skeleton height="100px" rounded="lg" />
      </Stack>
    </VStack>
  );
};
